import * as React from 'react';
import ReactJkMusicPlayer from "react-jinke-music-player";
import { connect } from 'react-redux';
import { loadList } from '../actions/playlist';
import { withTranslation } from 'react-i18next';

interface IState {
    options: any,
}

class AudioPlayer extends React.Component<any, IState> {
    constructor(props: any) {
        super(props);

        const {t} = this.props;

        this.state = {
            options: {
                seeked: true,
                showDownload: false,
                showPlayMode: true,
                showPlay: true,
                drag: true,
                showThemeSwitch: false,
                showMiniModeCover: false,
                openText: t("открыть"),
                playModeText: {
                    order: t("порядок"),
                    orderLoop: t("повтор всех"),
                    singleLoop: t("повтор одного"),
                    shufflePlay: t("случайно")
                },
                closeText: t("закрыть"),
                panelTitle: t("Список"),
                notContentText: t("Пусто"),
                autoPlay: true,
            }
        };
    }

    componentDidMount() {
        // if (this.props.auth.isAuthentificated)
        //     this.props.loadList();
    }

    render() {
        const {t} = this.props;

        return (
            <div>
                <ReactJkMusicPlayer {...this.state.options} extendsContent={[
                    this.props.auth.isAuthentificated && <a key={"favorite-btn"} className="load-favorites" onClick={(event: React.MouseEvent) => {
                        event.preventDefault();
                        this.props.loadList();
                    }}>
                        <i className="fa fa-heart"></i> {t("Мои избранные")}
                    </a>
                ]} autoPlay={true} playIndex={this.props.playlist.playIndex} audioLists={this.props.playlist.list} />
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        playlist: state.playlist,
        auth: state.auth
    };
}

export default connect(mapStateToProps, { loadList })(withTranslation()(AudioPlayer));